import type {User} from 'nutshell-core/users/users-types';

import {TagsEditor} from 'shells/tags-editor/tags-editor';
import type {Tag} from 'shells/tags-editor/tags-editor';

import type {PeepTagMapsFragment_tagMaps_edges as PeepTagMapEdge} from 'nutshell-graphql-types';

import {useGetTags} from '../../../core/select/hooks/use-get-tags';

import {usePeepTags} from './hooks/use-peep-tags';

import styles from '../../../core-entity/styles/tag-editor.module.css';

interface Props {
    entityId: string;
    entityType: 'CONTACT' | 'ACCOUNT';
    user: User;
    tagMaps: PeepTagMapEdge[] | undefined;
    onUpdateTags: (tags: Tag[]) => Promise<any>;
    maxItems?: number;
}

export function PeepTagsEditor(props: Props) {
    const {fetchMore} = useGetTags({
        tagType: props.entityType,
    });

    const {tags, handleFetchTags} = usePeepTags(props.tagMaps ?? [], (searchTerm) =>
        fetchMore(searchTerm, props.entityType)
    );

    return (
        <div className={styles['tag-container']}>
            <TagsEditor
                key={props.entityId}
                user={{
                    id: props.user.id,
                    name: props.user.name,
                }}
                fetchTags={handleFetchTags}
                appliedTags={tags}
                onUpdateTags={(tags) => {
                    props.onUpdateTags(tags);
                }}
                maxItems={props.maxItems}
            />
        </div>
    );
}
